// extracted by mini-css-extract-plugin
export default {"cardHeaderIcon":"c-e_cW","cardHeaderIcon_styleDefault":"c-e_cX","cardHeaderIcon_styleRed":"c-e_cY","cardHeaderIcon__content":"c-e_cZ"};